module.exports = __webpack_public_path__ + "img/google_play_dark.e3ea015.svg";